import { AppController } from '@hit/amorphic-types';
import { property, supertypeClass } from '@haventech/amorphic';
import { AgentDefaultCommissionSplit } from '../../../../common/js/agent/AgentDefaultCommissionSplit';
import { Policy } from '../../../../common/js/customer/Policy';
import { PolicyAgent } from '../../../../common/js/customer/PolicyAgent';
import { Controller } from '../Controller';
import { CoverpathUtilsBackEnd } from '../../../../coverpath-common/js/static/CoverpathUtilsBackEnd';

@supertypeClass({ toClient: true, toServer: true })
export class CommissionSplitsController extends AppController {
  @property({ getType: () => Controller })
  controller: Controller;

  static new(parentController: Controller): CommissionSplitsController {
    return new CommissionSplitsController().init(parentController);
  }

  init(parentController: Controller): this {
    this.controller = parentController;
    return this;
  }

  getController(): Controller {
    return this.controller;
  }

  async createCommissionSplits(primaryPolicy: Policy) {
    const { primaryPolicyAgent } = primaryPolicy;
    const defaultCommissionSplits = await this.getDefaultCommissionSplit(primaryPolicyAgent.primaryAgent);

    // When there is only primary/servicing agent exists
    if (!defaultCommissionSplits || defaultCommissionSplits.length < 1) {
      primaryPolicyAgent.ratio = 100;
      primaryPolicyAgent.renewalCommissionRatio = 100;
    }

    primaryPolicy.additionalPolicyAgents = [];
    for (const producerCommission of defaultCommissionSplits) {
      const { additionalAgent, ratio, renewalCommissionRatio } = producerCommission;
      if (primaryPolicyAgent.primaryAgent._id === additionalAgent._id) {
        primaryPolicyAgent.ratio = typeof ratio === 'number' ? ratio : 100;
        primaryPolicyAgent.renewalCommissionRatio =
          typeof renewalCommissionRatio === 'number' ? renewalCommissionRatio : 100;
        primaryPolicyAgent.agencyId = primaryPolicyAgent.primaryAgent.agencyId;
        primaryPolicyAgent.corpId = primaryPolicyAgent.primaryAgent.corpId;
        primaryPolicyAgent.corpAgency = CoverpathUtilsBackEnd.generateCorpAgencyString(primaryPolicyAgent.primaryAgent);
      } else {
        const policyAgent = PolicyAgent.create(primaryPolicy, additionalAgent);
        policyAgent.ratio = typeof ratio === 'number' ? ratio : 0;
        policyAgent.renewalCommissionRatio = typeof renewalCommissionRatio === 'number' ? renewalCommissionRatio : 0;
        policyAgent.agencyId = additionalAgent.agencyId;
        policyAgent.corpId = additionalAgent.corpId;
        policyAgent.corpAgency = CoverpathUtilsBackEnd.generateCorpAgencyString(additionalAgent);
        primaryPolicy.additionalPolicyAgents.push(policyAgent);
      }
    }
  }

  private async getDefaultCommissionSplit({ _id }): Promise<Array<AgentDefaultCommissionSplit>> {
    const defaultCommissionSplits = await AgentDefaultCommissionSplit.persistorFetchByQuery(
      { primary_agent_id: _id },
      { fetch: { additionalAgent: true }, session: this.controller.amorphic }
    );
    return defaultCommissionSplits;
  }
}
